<template>
    <div>
            <v-row justify="center">
                <v-col cols="9" class="pa-0 ma-0">
                    <v-alert v-if="hasConfirmParticipation" class="mb-2 mx-5" outlined type="info">
                        Έχετε επιβεβαιώσει την συμμετοχή σας στον Εύδοξο για το ακαδημαϊκό έτος {{academicYear}}.
                        <b @click="openHistoryModal" style="cursor: pointer"><u>
                            Ιστορικό
                        </u></b>
                    </v-alert>

                    <v-alert v-if="hasNotYetConfirmParticipation" class="mb-2 mx-5" outlined type="warning">
                        Δεν έχετε ακόμα επιβεβαιώσει την συμμετοχή σας στον Εύδοξο για το ακαδημαϊκό έτος
                        {{academicYear}}.
                        <b class="info--text" @click="openHistoryModal" style="cursor: pointer"><u>
                            Ιστορικό
                        </u></b>
                    </v-alert>

                    <v-alert v-if="hasYetConfirmParticipation" class="mb-2 mx-5" outlined type="error">
                        Έχετε επιλέξει οτι δεν θα συμμετάσχετε στον Εύδοξο για το ακαδημαϊκό έτος {{academicYear}}.
                        <b class="info--text" @click="openHistoryModal" style="cursor: pointer"><u>
                            Ιστορικό
                        </u></b>
                    </v-alert>

                    <!--                <v-alert v-if="eBookParticipation && $store.getters.homePageInformation.type != 'Allocator'" class="mb-2 mx-5" outlined type="info">-->
                    <!--                    Έχετε επιλέξει να διαθέτετε συγγράμματα και ηλεκτρονικά για το ακαδημαϊκό έτος {{academicYear}}.-->
                    <!--                </v-alert>-->
                    <!--                <v-alert v-if="!eBookParticipation && Object.keys($store.getters.homePageInformation).length > 0  && $store.getters.homePageInformation.type != 'Allocator'" class="mb-2 mx-5" outlined type="warning">-->
                    <!--                    Δεν έχετε επιλέξει να διαθέτετε συγγράμματα ηλεκτρονικά για το ακαδημαϊκό έτος {{academicYear}}.-->
                    <!--                </v-alert>&lt;!&ndash; the "Object.keys($store.getters.homePageInformation).length > 0" condition is for rendering purposes while not logged&ndash;&gt;-->

                </v-col>
            </v-row>
            <v-row justify="center" v-if="hasConfirmParticipation">
                <v-col cols="9" class="pa-0 ma-0">
                    <v-alert v-if="$store.getters.homePageInformation.bookPricingAllowedPeriod" v-model="$store.getters.bookInfoAlert"
                             border="left" prominent
                             transition="scale-transition"
                             type="warning" outlined class="mb-2 mx-5">
                        <template v-slot:close="">
                            <v-icon @click="$store.commit('setBookInfoAlert',false)">mdi-close-outline</v-icon>
                        </template>
                        Σας ενημερώνουμε πως έχετε ανενεργά ή και ακοστολόγητα συγγράμματα ή και μη ολοκληρωμένες εγγραφές στον λογαριασμό σας. Σας υπενθυμίζουμε πως για να θεωρηθεί ένα σύγγραμμα ως
                        ολοκληρωμένη εγγραφή και κατ' επέκτασιν να είναι επιλέξιμο από τις γραμματείες, θα πρέπει να έχουν όλα τα υποχρεωτικά του πεδία συμπληρωμένα,
                        να έχουν αναρτηθεί τα αρχεία του , να έχει κοστολογηθεί ηλεκτρονικά (ή να έχει λάβει τιμή από την Επιτροπή Κοστολόγησης) και να είναι ενεργό.

                    </v-alert>
                </v-col>
            </v-row>
        <v-container>
            <v-row>
                <v-col cols="12" lg="6" md="6" sm="12">
                    <v-card class="elevation-6">
                        <v-card-text>
                            <p class="title text--primary ml-3">
                                Στοιχεία Εκδότη</p>
                            <v-divider></v-divider>
                            <v-row v-if="$store.getters.homePageInformation.type != 'Allocator'">
                                <v-col>
                                    <v-list-item v-for="(informationA, n) in publisherInformationA">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>{{informationA.label}}</v-list-item-subtitle>
                                            <v-list-item-title v-if="informationA.value == 'publisherURL'">
                                                <a @click="openPublisherUrl">
                                                    {{$store.getters.homePageInformation[informationA.value]}}</a>
                                            </v-list-item-title>
                                            <v-list-item-title v-else>
                                                {{$store.getters.homePageInformation[informationA.value]}}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>

                                <v-col>
                                    <v-list-item v-for="(informationB, n) in publisherInformationB">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>{{informationB.label}}</v-list-item-subtitle>
                                            <v-list-item-title
                                                    v-if="informationB.value == 'legalPersonIdentificationIssuer'">
                                                {{$store.getters.homePageInformation[informationB.value]}}
                                                {{$store.getters.homePageInformation.legalPersonIdentificationIssueDate}}
                                            </v-list-item-title>
                                            <v-list-item-title v-else>
                                                {{$store.getters.homePageInformation[informationB.value]}}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>

                                </v-col>
                            </v-row>
                            <v-row v-else>
                                <v-col>
                                    <v-list-item v-for="(informationA, n) in allocatorInformationA">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>{{informationA.label}}</v-list-item-subtitle>
                                            <v-list-item-title v-if="informationA.value == 'publisherURL'">
                                                <a @click="openPublisherUrl">
                                                    {{$store.getters.homePageInformation[informationA.value]}}</a>
                                            </v-list-item-title>
                                            <v-list-item-title v-else>
                                                {{$store.getters.homePageInformation[informationA.value]}}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col>
                                    <v-list-item v-for="(informationB, n) in allocatorInformationB">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>{{informationB.label}}</v-list-item-subtitle>
                                            <v-list-item-title>
                                                {{$store.getters.homePageInformation[informationB.value]}}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>

                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions class="caption">
                            <v-row>
                                <v-col cols="12">
                                    <v-icon>create</v-icon>
                                    Για την επεξεργασία των παραπάνω στοιχείων επισκεφθείτε το
                                    <a href="https://submit.eudoxus.gr/" target="_blank"> https://submit.eudoxus.gr</a>
                                </v-col>
                            </v-row>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="12" lg="6" md="6" sm="12">
                    <v-card class="elevation-6">
                        <v-card-text>
                            <p class="title text--primary ml-3">
                                Στοιχεία Λογαριασμού
                            </p>
                            <v-divider></v-divider>
                            <v-row>
                                <v-col>
                                    <v-list-item v-for="(acountinformationA, n) in informationAccountA">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>{{acountinformationA.label}}</v-list-item-subtitle>
                                            <v-list-item-title>
                                                {{$store.getters.homePageInformation[acountinformationA.value]}}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-divider></v-divider>

                                    <v-list-item v-for="(acountinformationB, n) in informationAccountB">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>{{acountinformationB.label}}</v-list-item-subtitle>
                                            <v-list-item-title
                                                    v-if="acountinformationB.value == 'contactIdentificationNumber'">
                                                {{$store.getters.homePageInformation[acountinformationB.value]}}
                                                {{$store.getters.homePageInformation.contactIdentificationIssuer}}
                                                {{$store.getters.homePageInformation.contactIdentificationIssueDate}}
                                            </v-list-item-title>
                                            <v-list-item-title v-else>
                                                {{$store.getters.homePageInformation[acountinformationB.value]}}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-divider
                                            v-if="$store.getters.homePageInformation.type != 'Allocator'"></v-divider>

                                    <v-list-item v-for="(acountinformationC, n) in informationAccountC"
                                                 v-if="$store.getters.homePageInformation.type != 'Allocator'">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>{{acountinformationC.label}}</v-list-item-subtitle>
                                            <v-list-item-title>
                                                {{$store.getters.homePageInformation[acountinformationC.value]}}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>

                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <PublisherHistory :publisherHistory="publisherHistory"/>
        </v-container>
    </div>
</template>

<script>
    import PublisherHistory from "./PublisherHistory";
    import requests from "../../requests";
    export default {
        name: "HomePage",
        components: {PublisherHistory},
        data: () => ({
            publisherInformationA: [
                {label: 'Επωνυμία', value: 'publisherName'},
                {label: 'Διακριτικός Τίτλος', value: 'publisherTradeName'},
                {label: 'Α.Φ.Μ', value: 'publisherAFM'},
                {label: 'Δ.Ο.Υ', value: 'publisherDOY'},
                {label: 'Τηλέφωνο (Σταθερό)', value: 'publisherPhone'},
                {label: 'Τηλέφωνο (Κινητό)', value: 'publisherMobilePhone'},
                {label: 'Fax', value: 'publisherFax'},
                {label: 'Email', value: 'publisherEmail'},
                {label: 'Ιστοσελίδα', value: 'publisherURL'}
            ],
            publisherInformationB: [
                {label: 'Διεύθυνση', value: 'publisherAddress'},
                {label: 'Ταχυδρομικός Κώδικας', value: 'publisherZipCode'},
                {label: 'Πόλη', value: 'cityName'},
                {label: 'Νομός', value: 'prefectureName'},
                {label: 'Νόμιμος Εκπρόσωπος', value: 'legalPersonName'},
                {label: 'Τηλέφωνο Νόμιμου Εκπρόσωπου', value: 'legalPersonPhone'},
                {label: 'Email Νόμιμου Εκπρόσωπου', value: 'legalPersonEmail'},
                {label: 'Στοιχεία Ταυτότητας', value: 'legalPersonIdentificationIssuer'}
            ],
            informationAccountA: [
                {label: 'Όνομα Χρήστη', value: 'username'},
                {label: 'Email Λογαριασμού', value: 'email'},
                {label: 'Μοναδικός Κωδικός (id)', value: 'id'}
            ],
            informationAccountB: [
                {label: 'Υπεύθυνος για τον Εύδοξο', value: 'contactName'},
                {label: 'Τηλέφωνο Υπευθύνου για τον Εύδοξο', value: 'contactPhone'},
                {label: 'Κινητό Τηλέφωνο Υπευθύνου για τον Εύδοξο', value: 'contactMobilePhone'},
                {label: 'Email Υπευθύνου για τον Εύδοξο', value: 'contactEmail'},
                {label: 'Στοιχεία Ταυτότητας', value: 'contactIdentificationNumber'}
            ],
            informationAccountC: [
                {label: 'Αναπληρωτής Υπεύθυνος για τον Εύδοξο', value: 'alternateContactName'},
                {label: 'Τηλέφωνο Αναπληρωτή Υπευθύνου για τον Εύδοξο', value: 'alternateContactPhone'},
                {label: 'Κινητό Τηλέφωνο Αναπληρωτή Υπεύθυνου για τον Εύδοξο', value: 'alternateContactMobilePhone'},
                {label: 'Email Αναπληρωτή Υπεύθυνου για τον Εύδοξο', value: 'alternateContactEmail'}
            ],
            allocatorInformationA: [
                {label: 'Επωνυμία', value: 'publisherName'},
                {label: 'Τηλέφωνο (Σταθερό)', value: 'publisherPhone'},
                {label: 'Τηλέφωνο (Κινητό)', value: 'publisherMobilePhone'},
                {label: 'Fax', value: 'publisherFax'},
                {label: 'Email', value: 'publisherEmail'},
                {label: 'Ιστοσελίδα', value: 'publisherURL'},
            ],
            allocatorInformationB: [
                {label: 'Διεύθυνση', value: 'publisherAddress'},
                {label: 'Ταχυδρομικός Κώδικας', value: 'publisherZipCode'},
                {label: 'Πόλη', value: 'cityName'},
                {label: 'Νομός', value: 'prefectureName'},
            ],
            publisherHistory: []
        }),

        methods: {
            openPublisherUrl(){
                window.open(this.$store.getters.homePageInformation.publisherURL, '_blank');
            },


            // redirectTest(){
            //      var xhr = new XMLHttpRequest();
            //
            //      xhr.open("GET", "/external/auth?publisherId=14", true);
            //      xhr.setRequestHeader('Authentication', 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI3IiwiaWF0IjoxNjUwMzY4Njg5LCJleHAiOjE2NTAzNzU4ODl9.ZjYNnC8aTJ3CCcszTyjLu5pTMUw_UJtYKNta16ZnpyH4VUC78Z20WF4RIvh-iUOKlhMLXU3BOxFkzBuu_g62BQ');
            //      xhr.onload = function (e) {
            //          if (xhr.readyState === 4) {
            //              if (xhr.status === 200) {
            //                  console.log(xhr.responseText);
            //                  window.open("data:text/xml;charset=utf-8,"+xhr.responseText, "");//window.open('http://webtest.ebooks.eudoxus.gr/external/auth?publisherId=6', '_self');
            //              } else if (xhr.status === 302) {
            //                  console.log(xhr.responseText);
            //              } else {
            //                  console.error(xhr.statusText);
            //              }
            //          }
            //      };
            //      xhr.onerror = function (e) {
            //          console.error(xhr.statusText);
            //      };
            //      xhr.send(null);
            //  },

            openHistoryModal() {

                var homePageInformationHistorys = JSON.parse(JSON.stringify(this.$store.getters.homePageInformation.history));
                this.publisherHistory = [];

                for (var homePageInformationHistory in homePageInformationHistorys) {
                    if (homePageInformationHistorys.hasOwnProperty(homePageInformationHistory)) {
                        var item = homePageInformationHistorys[homePageInformationHistory];
                        this.publisherHistory.push(item);
                    }
                }
                this.$store.commit('setPublisherHistory', true);
            }

        },

        created() {
            window.scrollTo(0, 0);
        },

        computed: {

            academicYear: function () {

                var years = this.$store.getters.years;
                if (years.length > 0) {
                    return years[0].value + ' - ' + parseInt(years[0].value + 1)
                }
                return '';
            },

            hasConfirmParticipation: function () {

                var homePageInformation = this.$store.getters.homePageInformation;
                var currentYear = this.$store.getters.editedYear;
                if (Object.keys(homePageInformation).length > 0 && currentYear != undefined) {
                    if (Object.keys(homePageInformation.history).length > 0) {
                        if (homePageInformation.history[currentYear] != undefined) {
                            if (homePageInformation.history[currentYear].eudoxusMember) {
                                return true;
                            }
                        }
                    }
                }
                return false;
            },

            eBookParticipation: function () {

                var homePageInformation = this.$store.getters.homePageInformation;
                var currentYear = this.$store.getters.editedYear;
                if (Object.keys(homePageInformation).length > 0 && currentYear != undefined) {
                    if (Object.keys(homePageInformation.history).length > 0) {
                        if (homePageInformation.history[currentYear] != undefined) {
                            return homePageInformation.history[currentYear].eBookstoreMembership;
                        }
                    }
                }
                return false;
            },

            hasNotYetConfirmParticipation: function () {

                var homePageInformation = this.$store.getters.homePageInformation;
                var currentYear = this.$store.getters.editedYear;
                if (currentYear) {
                    if (Object.keys(homePageInformation).length > 0 && currentYear != undefined) {
                        if (Object.keys(homePageInformation.history).length > 0) {
                            if (homePageInformation.history[currentYear] == null || homePageInformation.history[currentYear].eudoxusMember == null) {
                                return true;
                            }
                        }
                    }
                }
                return false;
            },

            hasYetConfirmParticipation: function () {

                var homePageInformation = this.$store.getters.homePageInformation;
                var currentYear = this.$store.getters.editedYear;
                if (Object.keys(homePageInformation).length > 0 && currentYear != undefined) {
                    if (Object.keys(homePageInformation.history).length > 0) {
                        if (homePageInformation.history[currentYear] != undefined) {
                            if (!homePageInformation.history[currentYear].eudoxusMember && homePageInformation.history[currentYear].eudoxusMember != null) {
                                return true;
                            }
                        }
                    }
                }
                return false;
            }
        }
    }
</script>

<style scoped>

</style>